import React from 'react';
import { Div, P, Anchor } from '@kizi/core-components';

export const IncentiveContent = (): JSX.Element => (
  <Div display="flex" flexDirection="column">
    <P variant="bodyRegular">
      Sluit een abonnement af bij deze provider. Vul daarna het{' '}
      <Anchor
        href="https://www.overstappen.nl/internet/cashback"
        variant="anchorRegular"
        target="_blank"
        rel="noopener noreferrer"
      >
        cashbackformulier
      </Anchor>{' '}
      in op onze website, met dezelfde gegevens als je bestelling bij de
      provider. Je ontvangt het bedrag vervolgens binnen enkele weken op je
      rekening, conform de voorwaarden.
    </P>
  </Div>
);
